module.exports = __webpack_public_path__ + "static/img/forgot.e558599.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/forgot.jpg
// module id = 712
// module chunks = 21